import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context){
	var base = '.i-loginAction';
	$(base, context).each(function(){
		var component = $(this);
		var dropLink = component.find(base + '-head');
		var dropdown = dropLink.next(base + '-body');
		var isActive = false;

		function setActive(value) {
			component.toggleClass('m-active', value);
			$(document)[value ? 'on' : 'off']('click', closeHandler);

			isActive = value;
		}

		function toggleHandlerMd(e) {
			e.preventDefault();

			if (!dropLink.hasClass('m-active')) {
				setTimeout(function() {
					setActive(true);
				});
			} else {
				setTimeout(function() {
					setActive(false);
				});
			}
		}

		function closeHandler(e) {
			if ($(e.target).closest(dropdown).length === 0) {
				setActive(false);
			}
		}

		dropLink.on('click', toggleHandlerMd);
	});
});